import { use } from 'react';
import { EditorContext } from './EditorProvider.tsx';

export function useEditor() {
  const { editor } = use(EditorContext);
  return editor;
}
